import { ApolloProvider } from "@apollo/client";
import { useModalState } from "hooks";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { getClient } from "utils/client/graphql.client";
import { useNetwork } from "wagmi";
import Eth from "web3-eth";
import { ethers } from "ethers";
import WalletContext from "./WalletContext";

export const Status = {
  connecting: "connecting",
  connected: "connected",
  walletExist: "wallet-exist",
  disconnected: "disconnected",
};

const WalletProvider = ({ children }) => {
  const { chain } = useNetwork();
  const [chainId, setChainId] = useState(null);

  useEffect(() => {
    (async () => {
      const metamaskProvider =
        window.ethereum?.providers?.find((provider) => provider.isMetaMask) || window.ethereum;
      if (typeof metamaskProvider === "undefined") return;

      const eth = new Eth(metamaskProvider);
      const getChainId = await eth.getChainId();
      const chainHex = ethers.utils.hexValue(getChainId);

      setChainId(chainHex);
    })();
  }, []);

  const {
    isOpen: isWrongChain,
    onOpen: onSwitchChain,
    onClose: onCloseSwitchChain,
  } = useModalState();

  const { isOpen: isConnecting, onOpen: onConnecting, onClose: onCloseConnect } = useModalState();

  const client = useMemo(
    () => getClient(chain ? `0x${Number(chain?.id || 0).toString(16)}` : chainId),
    [chain, chainId]
  );

  useEffect(() => {
    if (chain?.unsupported) onSwitchChain();
  }, [chain?.unsupported, onSwitchChain]);

  return (
    <WalletContext.Provider
      value={{
        isWrongChain,
        onSwitchChain,
        onCloseSwitchChain,
        isConnecting,
        onConnecting,
        onCloseConnect,
      }}
    >
      <ApolloProvider client={client}>{children}</ApolloProvider>
    </WalletContext.Provider>
  );
};

WalletProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WalletProvider;
